import cn from 'classnames'
import React, { ComponentProps } from 'react'

export type ApproversUpsellSvgProps = {
  className?: string
} & ComponentProps<'svg'>
export default function ApproversUpsellSvg(props: ApproversUpsellSvgProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('ApproversUpsellSvg', className)}
      width="293"
      height="178"
      viewBox="0 0 293 178"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g filter="url(#filter0_d_18702_103860)">
        <ellipse
          cx="52.111"
          cy="105.651"
          rx="43.5456"
          ry="43.5471"
          fill="#B8D5EA"
        />
        <mask
          id="mask0_18702_103860"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="8"
          y="62"
          width="88"
          height="88"
        >
          <ellipse
            cx="52.1091"
            cy="105.649"
            rx="43.5456"
            ry="43.5471"
            fill="white"
          />
          <ellipse
            cx="52.111"
            cy="105.65"
            rx="43.5456"
            ry="43.5471"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_18702_103860)">
          <path
            d="M26.1862 149.2C20.2401 122.807 29.1592 109.611 52.9437 109.611C76.7282 109.611 85.6474 122.807 79.7013 149.2"
            fill="white"
          />
          <g filter="url(#filter1_d_18702_103860)">
            <path
              d="M52.9344 121.486C62.3922 121.486 70.0592 113.51 70.0592 103.672C70.0592 93.8328 62.3922 85.8569 52.9344 85.8569C43.4766 85.8569 35.8096 93.8328 35.8096 103.672C35.8096 113.51 43.4766 121.486 52.9344 121.486Z"
              fill="#1B2C4F"
            />
          </g>
        </g>
      </g>
      <g filter="url(#filter2_d_18702_103860)">
        <ellipse
          cx="225.891"
          cy="105.651"
          rx="43.5456"
          ry="43.5471"
          fill="#B8D5EA"
        />
        <mask
          id="mask1_18702_103860"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="182"
          y="62"
          width="88"
          height="88"
        >
          <ellipse
            cx="225.889"
            cy="105.649"
            rx="43.5456"
            ry="43.5471"
            fill="white"
          />
          <ellipse
            cx="225.89"
            cy="105.65"
            rx="43.5456"
            ry="43.5471"
            fill="#491A1A"
          />
        </mask>
        <g mask="url(#mask1_18702_103860)">
          <path
            d="M199.967 149.2C194.021 122.807 202.94 109.611 226.725 109.611C250.509 109.611 259.429 122.807 253.483 149.2"
            fill="white"
          />
          <g filter="url(#filter3_d_18702_103860)">
            <path
              d="M226.716 121.486C236.173 121.486 243.84 113.51 243.84 103.672C243.84 93.8328 236.173 85.8569 226.716 85.8569C217.258 85.8569 209.591 93.8328 209.591 103.672C209.591 113.51 217.258 121.486 226.716 121.486Z"
              fill="#1B2C4F"
            />
          </g>
        </g>
      </g>
      <g filter="url(#filter4_d_18702_103860)">
        <ellipse
          cx="138.8"
          cy="77.428"
          rx="65.3184"
          ry="65.3206"
          fill="#1B2C4F"
        />
        <mask
          id="mask2_18702_103860"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="73"
          y="12"
          width="132"
          height="132"
        >
          <ellipse
            cx="138.731"
            cy="77.4251"
            rx="65.3184"
            ry="65.3206"
            fill="#1B2C4F"
          />
          <ellipse
            cx="138.731"
            cy="77.6954"
            rx="65.3184"
            ry="65.3206"
            fill="white"
          />
        </mask>
        <g mask="url(#mask2_18702_103860)">
          <path
            d="M99.914 142.752C90.9949 103.163 104.374 83.3694 140.05 83.3694C175.727 83.3694 189.106 103.163 180.187 142.752"
            fill="#BFDEF3"
          />
          <g filter="url(#filter5_d_18702_103860)">
            <path
              d="M140.038 101.182C154.225 101.182 165.725 89.2185 165.725 74.4603C165.725 59.7022 154.225 47.7383 140.038 47.7383C125.851 47.7383 114.351 59.7022 114.351 74.4603C114.351 89.2185 125.851 101.182 140.038 101.182Z"
              fill="white"
            />
          </g>
        </g>
      </g>
      <ellipse
        cx="206.091"
        cy="45.2634"
        rx="34.4613"
        ry="34.4611"
        fill="url(#paint0_linear_18702_103860)"
      />
      <mask
        id="path-17-outside-1_18702_103860"
        maskUnits="userSpaceOnUse"
        x="181"
        y="19.5"
        width="52"
        height="52"
        fill="black"
      >
        <rect fill="white" x="181" y="19.5" width="52" height="52" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M227.454 33.3982L226.547 39.9835L230.627 45.3135L226.546 50.6436L227.455 57.2226L221.217 59.7168L218.723 65.9545L212.137 65.0467L206.813 69.127L201.489 65.0467L194.904 65.9549L192.41 59.7171L186.172 57.223L187.08 50.6436L183 45.3135L187.08 39.9894L186.172 33.4041L192.404 30.9044L194.904 24.6725L201.489 25.5802L206.813 21.5L212.138 25.5802L218.723 24.6725L221.222 30.9044L227.454 33.3982ZM220.36 58.8581L226.228 56.5211L225.387 50.3559L229.232 45.3122L225.376 40.2684L226.228 34.1033L220.371 31.7549L218.023 25.887L211.858 26.7388L206.814 22.8944L201.77 26.7501L195.605 25.8983L193.268 31.7549L187.4 34.1033L188.241 40.2684L184.396 45.3122L188.252 50.3559L187.4 56.521L193.268 58.8581L195.605 64.726L201.77 63.8855L206.814 67.73L211.858 63.8742L218.023 64.7261L220.36 58.8581Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M227.454 33.3982L226.547 39.9835L230.627 45.3135L226.546 50.6436L227.455 57.2226L221.217 59.7168L218.723 65.9545L212.137 65.0467L206.813 69.127L201.489 65.0467L194.904 65.9549L192.41 59.7171L186.172 57.223L187.08 50.6436L183 45.3135L187.08 39.9894L186.172 33.4041L192.404 30.9044L194.904 24.6725L201.489 25.5802L206.813 21.5L212.138 25.5802L218.723 24.6725L221.222 30.9044L227.454 33.3982ZM220.36 58.8581L226.228 56.5211L225.387 50.3559L229.232 45.3122L225.376 40.2684L226.228 34.1033L220.371 31.7549L218.023 25.887L211.858 26.7388L206.814 22.8944L201.77 26.7501L195.605 25.8983L193.268 31.7549L187.4 34.1033L188.241 40.2684L184.396 45.3122L188.252 50.3559L187.4 56.521L193.268 58.8581L195.605 64.726L201.77 63.8855L206.814 67.73L211.858 63.8742L218.023 64.7261L220.36 58.8581Z"
        fill="white"
      />
      <path
        d="M226.547 39.9835L225.358 39.8196L225.29 40.3155L225.594 40.7129L226.547 39.9835ZM227.454 33.3982L228.643 33.5621L228.771 32.6326L227.9 32.2841L227.454 33.3982ZM230.627 45.3135L231.58 46.043L232.138 45.3136L231.58 44.5841L230.627 45.3135ZM226.546 50.6436L225.594 49.9141L225.289 50.3117L225.358 50.8076L226.546 50.6436ZM227.455 57.2226L227.9 58.3368L228.772 57.9883L228.643 57.0585L227.455 57.2226ZM221.217 59.7168L220.771 58.6025L220.294 58.7935L220.103 59.2712L221.217 59.7168ZM218.723 65.9545L218.559 67.1432L219.489 67.2714L219.837 66.4L218.723 65.9545ZM212.137 65.0467L212.301 63.858L211.805 63.7896L211.407 64.0943L212.137 65.0467ZM206.813 69.127L206.083 70.0794L206.813 70.6388L207.543 70.0794L206.813 69.127ZM201.489 65.0467L202.219 64.0943L201.822 63.7896L201.325 63.858L201.489 65.0467ZM194.904 65.9549L193.79 66.4004L194.139 67.2719L195.068 67.1436L194.904 65.9549ZM192.41 59.7171L193.524 59.2716L193.333 58.7939L192.856 58.6029L192.41 59.7171ZM186.172 57.223L184.984 57.059L184.855 57.9887L185.727 58.3372L186.172 57.223ZM187.08 50.6436L188.269 50.8076L188.337 50.3116L188.033 49.9141L187.08 50.6436ZM183 45.3135L182.048 44.5836L181.488 45.3131L182.047 46.043L183 45.3135ZM187.08 39.9894L188.033 40.7194L188.337 40.3218L188.269 39.8256L187.08 39.9894ZM186.172 33.4041L185.726 32.2904L184.856 32.6393L184.984 33.568L186.172 33.4041ZM192.404 30.9044L192.851 32.0182L193.327 31.8272L193.518 31.3511L192.404 30.9044ZM194.904 24.6725L195.068 23.4837L194.139 23.3557L193.79 24.2258L194.904 24.6725ZM201.489 25.5802L201.325 26.769L201.822 26.8374L202.219 26.5327L201.489 25.5802ZM206.813 21.5L207.543 20.5475L206.813 19.9881L206.083 20.5475L206.813 21.5ZM212.138 25.5802L211.408 26.5327L211.805 26.8374L212.301 26.769L212.138 25.5802ZM218.723 24.6725L219.837 24.2258L219.488 23.3557L218.559 23.4837L218.723 24.6725ZM221.222 30.9044L220.109 31.3511L220.3 31.8277L220.777 32.0185L221.222 30.9044ZM226.228 56.5211L226.672 57.6359L227.543 57.2887L227.417 56.359L226.228 56.5211ZM220.36 58.8581L219.916 57.7433L219.436 57.9344L219.245 58.4141L220.36 58.8581ZM225.387 50.3559L224.433 49.6285L224.131 50.0246L224.198 50.518L225.387 50.3559ZM229.232 45.3122L230.186 46.0396L230.741 45.3111L230.185 44.5834L229.232 45.3122ZM225.376 40.2684L224.187 40.1041L224.119 40.5997L224.422 40.9971L225.376 40.2684ZM226.228 34.1033L227.416 34.2675L227.545 33.3385L226.674 32.9895L226.228 34.1033ZM220.371 31.7549L219.257 32.2008L219.448 32.6776L219.924 32.8687L220.371 31.7549ZM218.023 25.887L219.137 25.4411L218.788 24.5698L217.858 24.6983L218.023 25.887ZM211.858 26.7388L211.13 27.6932L211.527 27.9959L212.022 27.9275L211.858 26.7388ZM206.814 22.8944L207.541 21.94L206.813 21.3847L206.085 21.941L206.814 22.8944ZM201.77 26.7501L201.606 27.9388L202.101 28.0073L202.499 27.7035L201.77 26.7501ZM195.605 25.8983L195.769 24.7096L194.839 24.581L194.491 25.4535L195.605 25.8983ZM193.268 31.7549L193.714 32.869L194.192 32.6778L194.383 32.1997L193.268 31.7549ZM187.4 34.1033L186.954 32.9892L186.085 33.3372L186.211 34.2654L187.4 34.1033ZM188.241 40.2684L189.195 40.9958L189.497 40.5997L189.43 40.1063L188.241 40.2684ZM184.396 45.3122L183.442 44.5847L182.886 45.3132L183.443 46.0409L184.396 45.3122ZM188.252 50.3559L189.441 50.5202L189.509 50.0246L189.205 49.6272L188.252 50.3559ZM187.4 56.521L186.211 56.3568L186.083 57.288L186.956 57.6359L187.4 56.521ZM193.268 58.8581L194.383 58.4141L194.192 57.9343L193.712 57.7433L193.268 58.8581ZM195.605 64.726L194.49 65.17L194.837 66.0418L195.767 65.915L195.605 64.726ZM201.77 63.8855L202.498 62.9312L202.101 62.6293L201.608 62.6965L201.77 63.8855ZM206.814 67.73L206.086 68.6844L206.815 69.2396L207.543 68.6833L206.814 67.73ZM211.858 63.8742L212.022 62.6855L211.526 62.617L211.129 62.9209L211.858 63.8742ZM218.023 64.7261L217.858 65.9148L218.79 66.0434L219.138 65.1701L218.023 64.7261ZM226.547 39.9835L227.735 40.1474L228.643 33.5621L227.454 33.3982L226.266 33.2343L225.358 39.8196L226.547 39.9835ZM230.627 45.3135L231.58 44.5841L227.5 39.2541L226.547 39.9835L225.594 40.7129L229.674 46.0429L230.627 45.3135ZM226.546 50.6436L227.499 51.373L231.58 46.043L230.627 45.3135L229.674 44.5841L225.594 49.9141L226.546 50.6436ZM227.455 57.2226L228.643 57.0585L227.735 50.4795L226.546 50.6436L225.358 50.8076L226.266 57.3867L227.455 57.2226ZM221.217 59.7168L221.662 60.831L227.9 58.3368L227.455 57.2226L227.009 56.1083L220.771 58.6025L221.217 59.7168ZM218.723 65.9545L219.837 66.4L222.331 60.1623L221.217 59.7168L220.103 59.2712L217.608 65.509L218.723 65.9545ZM212.137 65.0467L211.974 66.2355L218.559 67.1432L218.723 65.9545L218.887 64.7657L212.301 63.858L212.137 65.0467ZM206.813 69.127L207.543 70.0794L212.867 65.9992L212.137 65.0467L211.407 64.0943L206.083 68.1745L206.813 69.127ZM201.489 65.0467L200.759 65.9992L206.083 70.0794L206.813 69.127L207.543 68.1745L202.219 64.0943L201.489 65.0467ZM194.904 65.9549L195.068 67.1436L201.653 66.2355L201.489 65.0467L201.325 63.858L194.74 64.7661L194.904 65.9549ZM192.41 59.7171L191.296 60.1627L193.79 66.4004L194.904 65.9549L196.019 65.5094L193.524 59.2716L192.41 59.7171ZM186.172 57.223L185.727 58.3372L191.965 60.8314L192.41 59.7171L192.856 58.6029L186.618 56.1087L186.172 57.223ZM187.08 50.6436L185.891 50.4795L184.984 57.059L186.172 57.223L187.361 57.387L188.269 50.8076L187.08 50.6436ZM183 45.3135L182.047 46.043L186.127 51.373L187.08 50.6436L188.033 49.9141L183.953 44.5841L183 45.3135ZM187.08 39.9894L186.128 39.2595L182.048 44.5836L183 45.3135L183.952 46.0435L188.033 40.7194L187.08 39.9894ZM186.172 33.4041L184.984 33.568L185.891 40.1533L187.08 39.9894L188.269 39.8256L187.361 33.2402L186.172 33.4041ZM192.404 30.9044L191.958 29.7907L185.726 32.2904L186.172 33.4041L186.619 34.5178L192.851 32.0182L192.404 30.9044ZM194.904 24.6725L193.79 24.2258L191.291 30.4577L192.404 30.9044L193.518 31.3511L196.018 25.1192L194.904 24.6725ZM201.489 25.5802L201.653 24.3915L195.068 23.4837L194.904 24.6725L194.74 25.8612L201.325 26.769L201.489 25.5802ZM206.813 21.5L206.083 20.5475L200.759 24.6278L201.489 25.5802L202.219 26.5327L207.543 22.4525L206.813 21.5ZM212.138 25.5802L212.867 24.6278L207.543 20.5475L206.813 21.5L206.083 22.4525L211.408 26.5327L212.138 25.5802ZM218.723 24.6725L218.559 23.4837L211.974 24.3915L212.138 25.5802L212.301 26.769L218.887 25.8612L218.723 24.6725ZM221.222 30.9044L222.336 30.4577L219.837 24.2258L218.723 24.6725L217.609 25.1192L220.109 31.3511L221.222 30.9044ZM227.454 33.3982L227.9 32.2841L221.668 29.7903L221.222 30.9044L220.777 32.0185L227.009 34.5123L227.454 33.3982ZM226.228 56.5211L225.784 55.4062L219.916 57.7433L220.36 58.8581L220.804 59.9729L226.672 57.6359L226.228 56.5211ZM225.387 50.3559L224.198 50.518L225.039 56.6832L226.228 56.5211L227.417 56.359L226.576 50.1939L225.387 50.3559ZM229.232 45.3122L228.277 44.5847L224.433 49.6285L225.387 50.3559L226.342 51.0834L230.186 46.0396L229.232 45.3122ZM225.376 40.2684L224.422 40.9971L228.278 46.0409L229.232 45.3122L230.185 44.5834L226.329 39.5396L225.376 40.2684ZM226.228 34.1033L225.039 33.939L224.187 40.1041L225.376 40.2684L226.565 40.4326L227.416 34.2675L226.228 34.1033ZM220.371 31.7549L219.924 32.8687L225.781 35.2171L226.228 34.1033L226.674 32.9895L220.818 30.6411L220.371 31.7549ZM218.023 25.887L216.909 26.3328L219.257 32.2008L220.371 31.7549L221.485 31.3091L219.137 25.4411L218.023 25.887ZM211.858 26.7388L212.022 27.9275L218.187 27.0757L218.023 25.887L217.858 24.6983L211.693 25.5501L211.858 26.7388ZM206.814 22.8944L206.086 23.8487L211.13 27.6932L211.858 26.7388L212.585 25.7844L207.541 21.94L206.814 22.8944ZM201.77 26.7501L202.499 27.7035L207.543 23.8477L206.814 22.8944L206.085 21.941L201.041 25.7968L201.77 26.7501ZM195.605 25.8983L195.441 27.087L201.606 27.9388L201.77 26.7501L201.934 25.5614L195.769 24.7096L195.605 25.8983ZM193.268 31.7549L194.383 32.1997L196.72 26.343L195.605 25.8983L194.491 25.4535L192.153 31.3102L193.268 31.7549ZM187.4 34.1033L187.846 35.2174L193.714 32.869L193.268 31.7549L192.822 30.6408L186.954 32.9892L187.4 34.1033ZM188.241 40.2684L189.43 40.1063L188.589 33.9412L187.4 34.1033L186.211 34.2654L187.052 40.4305L188.241 40.2684ZM184.396 45.3122L185.351 46.0396L189.195 40.9958L188.241 40.2684L187.286 39.5409L183.442 44.5847L184.396 45.3122ZM188.252 50.3559L189.205 49.6272L185.349 44.5834L184.396 45.3122L183.443 46.0409L187.299 51.0847L188.252 50.3559ZM187.4 56.521L188.589 56.6853L189.441 50.5202L188.252 50.3559L187.063 50.1917L186.211 56.3568L187.4 56.521ZM193.268 58.8581L193.712 57.7433L187.844 55.4062L187.4 56.521L186.956 57.6359L192.824 59.9729L193.268 58.8581ZM195.605 64.726L196.72 64.282L194.383 58.4141L193.268 58.8581L192.153 59.3021L194.49 65.17L195.605 64.726ZM201.77 63.8855L201.608 62.6965L195.443 63.537L195.605 64.726L195.767 65.915L201.932 65.0745L201.77 63.8855ZM206.814 67.73L207.541 66.7756L202.498 62.9312L201.77 63.8855L201.043 64.8399L206.086 68.6844L206.814 67.73ZM211.858 63.8742L211.129 62.9209L206.085 66.7766L206.814 67.73L207.543 68.6833L212.586 64.8276L211.858 63.8742ZM218.023 64.7261L218.187 63.5374L212.022 62.6855L211.858 63.8742L211.693 65.0629L217.858 65.9148L218.023 64.7261ZM220.36 58.8581L219.245 58.4141L216.908 64.2821L218.023 64.7261L219.138 65.1701L221.475 59.3021L220.36 58.8581Z"
        fill="white"
        mask="url(#path-17-outside-1_18702_103860)"
      />
      <path
        d="M197.973 46.4501L203.615 51.7654L215.681 39.0415"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_d_18702_103860"
          x="0.922785"
          y="54.4609"
          width="117.661"
          height="117.665"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="7.64264" dy="7.64264" />
          <feGaussianBlur stdDeviation="7.64264" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18702_103860"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_18702_103860"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_18702_103860"
          x="12.493"
          y="74.1987"
          width="80.8831"
          height="82.2625"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="11.6583" />
          <feGaussianBlur stdDeviation="11.6583" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18702_103860"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_18702_103860"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_18702_103860"
          x="174.703"
          y="54.4609"
          width="117.661"
          height="117.665"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="7.64264" dy="7.64264" />
          <feGaussianBlur stdDeviation="7.64264" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18702_103860"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_18702_103860"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_18702_103860"
          x="186.274"
          y="74.1987"
          width="80.8831"
          height="82.2625"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="11.6583" />
          <feGaussianBlur stdDeviation="11.6583" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18702_103860"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_18702_103860"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_18702_103860"
          x="62.0175"
          y="0.643456"
          width="176.493"
          height="176.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="11.464" dy="11.464" />
          <feGaussianBlur stdDeviation="11.464" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18702_103860"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_18702_103860"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_d_18702_103860"
          x="79.3758"
          y="30.2509"
          width="121.324"
          height="123.394"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="17.4874" />
          <feGaussianBlur stdDeviation="17.4874" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18702_103860"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_18702_103860"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_18702_103860"
          x1="231"
          y1="17"
          x2="176"
          y2="65.5003"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00D0B4" />
          <stop offset="1" stopColor="#4186F6" />
        </linearGradient>
      </defs>
    </svg>
  )
}
